import { Controller, Scene } from "react-scrollmagic";
import { Tween } from "react-gsap";

import landingTiger from "../../assets/landing/landing_init.png";
import earringImage from "../../assets/landing/landing_earring.png";
import maskImage from "../../assets/landing/landing_mask.png";
import hairImage from "../../assets/landing/landing_hair.png";
import SaleButton from "../../components/SaleButton";
import { useMediaQuery } from "@mui/material";
import { useRef } from "react";
import { MAIN } from "../../constants";

const bgImageHeight = 3000;
const toolbarHeight = 104;
const scrollableHeight = bgImageHeight - window.innerHeight;

const MainSection = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const isMobile = useMediaQuery("(max-width:450px)");
  const imageHeight = isMobile ? 300 : 500;
  //const topPx = window.innerHeight - imageHeight;
  const ease = "none";
  return (
    <section
      style={{
        height: bgImageHeight - toolbarHeight + toolbarHeight,
        width: "100%",
        position: "relative",
      }}
      id="main"
      ref={sectionRef}
    >
      <Controller>
        <Scene duration={scrollableHeight} enabled={true}>
          {(progress: number) => {
            return (
              <>
                <div
                  style={{
                    position: "sticky",
                    width: "100%",
                    height: window.innerHeight,
                    top: 0,
                    zIndex: 20,
                    overflow: "hidden",
                  }}
                >
                  <h2
                    style={{
                      position: "absolute",
                      width: "100%",
                      textAlign: "center",
                      top: isMobile ? "20%" : "10%",
                    }}
                  >
                    REBEL TIGER CLUB
                  </h2>
                  <Tween
                    from={{
                      transform: "translate(-400px, -50px)",
                    }}
                    to={{
                      transform: `translate(0px, 0px)`,
                    }}
                    ease={ease}
                    totalProgress={progress}
                    paused
                  >
                    <img
                      style={{
                        zIndex: 5,
                      }}
                      src={earringImage}
                      alt="eyes"
                      className="tiger-image main-images"
                    ></img>
                  </Tween>
                  <Tween
                    from={{
                      transform: "translate(-350px, -200px)",
                    }}
                    to={{
                      transform: `translate(0px, 0px)`,
                    }}
                    ease={ease}
                    totalProgress={progress}
                    paused
                  >
                    <img
                      style={{
                        zIndex: 4,
                      }}
                      src={hairImage}
                      alt="hair"
                      className="tiger-image main-images"
                    ></img>
                  </Tween>
                  <Tween
                    from={{
                      transform: `translate(400px, -350px)`,
                    }}
                    to={{
                      transform: `translate(0px, 0px)`,
                    }}
                    ease={ease}
                    totalProgress={progress}
                    paused
                  >
                    <img
                      style={{
                        zIndex: 4,
                      }}
                      src={maskImage}
                      className="tiger-image main-images"
                      alt="mask"
                    ></img>
                  </Tween>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      height: imageHeight,
                      zIndex: 1,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "end",
                    }}
                    className="pinned-div"
                  >
                    <SaleButton
                      title={MAIN.preSale.title}
                      subtitle={MAIN.preSale.subtitle}
                      url={MAIN.preSale.url}
                    >
                      {MAIN.preSale.content}
                    </SaleButton>
                    <img
                      src={landingTiger}
                      alt="Rebel Tiger"
                      className="tiger-image"
                    ></img>
                    <SaleButton
                      title={MAIN.publicSale.title}
                      subtitle={MAIN.publicSale.subtitle}
                      url={MAIN.publicSale.url}
                    >
                      {MAIN.publicSale.content}
                    </SaleButton>
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 10,
                        height: imageHeight,
                        width: "100%",
                        backgroundImage:
                          "linear-gradient(rgba(131, 58, 180, 0) 0%, rgba(0, 0, 0, 0.5) 90%, rgb(0, 0, 0) 100%)",
                        bottom: 0,
                      }}
                    ></div>
                  </div>
                </div>
              </>
            );
          }}
        </Scene>
      </Controller>
    </section>
  );
};

export default MainSection;
